import { ValidatorFn } from '@angular/forms/src/directives/validators';
import { Validation } from '../validation.interface';
import { Validators } from '@angular/forms';

export class RequiredModel implements Validation {
  static REQUIRED = 'required';

  getValidatorsName(): string {
    return RequiredModel.REQUIRED;
  }

  getValidatorsErrorDescription(): string {
    return 'Campo obrigatório';
  }

  getValidatorsRule(): ValidatorFn {
    return Validators.required;
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/input/rules/implementations/required.model.ts